import EfImg from '@elem/ui/ef-img';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function Introduction() {
    const { t } = useLang('referral.intrdocution');

    return (
        <div className={styles.Introduction}>
            <div className="introd-content">
                <div className="introd-img">
                    <EfImg
                        pc={'https://websiteoss.ecoflow.com/upload/image/1748349286473/introd_pc.jpg'}
                        pad={'https://websiteoss.ecoflow.com/upload/image/1748349289483/introd_h5.jpg'}
                        h5={'https://websiteoss.ecoflow.com/upload/image/1748349289483/introd_h5.jpg'}
                    />
                </div>
                <div className="introd-title">
                    {t.rich('title', {
                        light: (text: string) => <span className="light">{text}</span>,
                    })}
                </div>
            </div>
        </div>
    );
}
